import { render } from "./PunchingShear.vue?vue&type=template&id=ba847194&scoped=true"
import script from "./PunchingShear.vue?vue&type=script&lang=js"
export * from "./PunchingShear.vue?vue&type=script&lang=js"

import "./PunchingShear.vue?vue&type=style&index=0&id=ba847194&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba847194"]])

export default __exports__